var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"el-icon-data-line mr-5 cursor-pointer",attrs:{"title":_vm.$t('integration.monitoring_point_chart')},on:{"click":_vm.toChart}})}
var staticRenderFns = []

export { render, staticRenderFns }